import React from 'react'
import { SvgVector2 } from '../types'

interface RotationProps {
	/**
	 * The center by which you want to rotate
	 */
	origin: SvgVector2
	/**
	 * Starting Angle
	 */
	fromΘ: number
	/**
	 * Ending Angle
	 */
	toΘ: number
	/**
	 * In Milliseconds
	 */
	duration: number
}

/**
 * A declarative Rotation animation that exposes a ref to allow imperative animations
 */
export const RotationAnimation = React.forwardRef<SVGAnimateTransformElement, RotationProps>((props, ref) => {
	return (
		<animateTransform
			ref={ref}
			attributeName="transform"
			attributeType="XML"
			type="rotate"
			fill="freeze"
			restart="whenNotActive"
			from={`${props.fromΘ} ${props.origin}`}
			to={`${props.toΘ} ${props.origin}`}
			dur={props.duration / 1000} // SVGs animate in seconds
			begin="indefinite"
			repeatCount="1"
		/>
	)
})
